import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FadeLoader } from 'react-spinners';
import config from '../../../config';
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import { Modal } from 'antd';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import NdoeSpinner from '../../../components/ndoe/NdoeSpinner';
import { NdoeImage } from '../../../components/ndoe';
import useMontantsEchange from '../../../hooks/useMontantsEchange';
import WizardStepper from '../../pageLivreur/WizardStepper';
import '../../pageLivreur/deliveryWizard.css';
import './echangeWizard.css';

// Étapes du wizard de création d'échange (une décision par écran).
const EW_STEPS = [
  { key: 'type', label: 'Type' },
  { key: 'mode', label: 'Réalisation' },
  { key: 'recap', label: 'Valider' },
];

const EchangeCommande = ({idVariant, idCommande}) => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [data, setData] = useState([]);
    const location = useLocation();
    const id = location.pathname.split('/')[2];
    const id_commande = location.pathname.split('/')[3];
    const searchParams = new URLSearchParams(location.search);
    const idDetail = searchParams.get('id_detail');
    const [quantite, setQuantite] = useState(1);
    const [taille, setTaille] = useState(null);
    const [getTaille, setGetTaille] = useState([]);
    const [loading, setLoading] = useState(true);
    const [variante, setVariante] = useState([]);
    const [prix, setPrix] = useState();
    const [inventaireTotalOne, setInventaireTotalOne] = useState([]);
    const [idVarianteProduit, setIdVarianteProduit] = useState([]);
    const [stock, setStock] = useState([]);
    const [getCommande, setGetCommande] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const userId = useSelector((state) => state.user.currentUser.id);
    // Le droit de voir l'argent d'un échange vit dans UN seul endroit désormais
    // (src/hooks/useMontantsEchange.js) : il était recopié dans quatre fichiers
    // et avait déjà divergé de l'historique du Centre des échanges.
    const peutVoirPrix = useMontantsEchange();
    const navigate = useNavigate();
    const [livreur, setLivreur] = useState([]);
    const [getLivreur, setGetLivreur] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [aLivrer, setAlivrer] = useState(false);   // Cas B : différer l'échange à la livraison
    const [avarieAncienne, setAvarieAncienne] = useState(false);   // ancienne paire défectueuse → avarie (magasin)
    const [etape, setEtape] = useState('type');   // étape courante du wizard de confirmation

    // Écart de prix de l'échange (Cas B). Le serveur PROPOSE le prix de la
    // nouvelle paire en le comparant à ce que la cliente paie RÉELLEMENT (le
    // prix de la vente active, souvent négocié) ; on peut le corriger si on en a
    // le droit. `prixRetenu` à null = on garde le montant proposé.
    const [apercu, setApercu] = useState(null);
    const [apercuErreur, setApercuErreur] = useState(null);
    const [prixRetenu, setPrixRetenu] = useState(null);
    const [editPrix, setEditPrix] = useState(false);

    // Prix unitaire réellement envoyé au serveur pour un échange à livrer.
    const prixEchange = prixRetenu !== null && prixRetenu !== ''
        ? Number(prixRetenu)
        : (apercu ? Number(apercu.prix_propose) : null);
    // Écart recalculé côté écran pour que le montant suive la correction saisie.
    const ecartEffectif = apercu && prixEchange !== null
        ? Number((prixEchange - Number(apercu.ancienne.prix)).toFixed(2))
        : null;

    // Aperçu de l'écart, chargé à l'entrée du récapitulatif d'un échange À LIVRER
    // (le seul flux dont le serveur sait recalculer l'argent). On repart de zéro
    // à chaque ouverture : une correction saisie ne doit pas survivre à un
    // changement de paire ou de commande.
    useEffect(() => {
        if (etape !== 'recap' || !aLivrer || !idDetail || !idVarianteProduit) { return undefined; }
        let vivant = true;
        setApercuErreur(null);
        axios.get(`${DOMAIN}/api/livraison/echange-a-livrer/apercu-prix`, {
            params: { id_detail_commande: idDetail, id_variante_nouvelle: idVarianteProduit },
        })
            .then(({ data }) => { if (vivant) setApercu(data); })
            .catch((err) => {
                if (!vivant) return;
                setApercu(null);
                setApercuErreur(err?.response?.data?.error || "Écart de prix indisponible.");
            });
        return () => { vivant = false; };
    }, [etape, aLivrer, idDetail, idVarianteProduit, DOMAIN]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/produit/varianteDetail/${idVariant}`);
                setData(data);
                setVariante(data[0]?.code_variant);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                toast.error("Impossible de charger le produit de remplacement.");
            }
        };
        fetchData();
    }, [id, idVariant]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/livreur`);
                setGetLivreur(data);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/inventaire/${variante}`);
                const tailles = data?.map(item => ({ id_taille: item.id_taille, taille: item.taille }));
                setGetTaille(tailles);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN, variante]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/inventaire/inventaireTotalOne/${variante}`);
                setInventaireTotalOne(data[0].nombre_total_de_paires);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN, variante]);

    const handleQuantity = (type) => {
        type === "inc" ? setQuantite(quantite + 1) 
                      : quantite > 1 && setQuantite(quantite - 1);
    };

    const groupedData = data.reduce((acc, item) => {
        const { id_produit, nom_produit, code_produit, code_article, pointure, date_entrant, nom_marque, nom_categorie, nom_matiere, nom_cible, code_pays, description, prix, nom_famille, stock, img, ...rest } = item;

        if (!acc[id_produit]) {
          acc[id_produit] = { id_produit, nom_produit, code_produit, code_article, pointure: [], date_entrant, nom_marque, nom_categorie, nom_matiere, nom_cible, code_pays, description, prix, nom_famille, stock, img };
        }

        acc[id_produit].pointure.push(pointure);

        return acc;
    }, {});

    const result = Object.values(groupedData);

    useEffect(() => {
        const Vprix = result.map((dd) => dd.prix);
        const totalPrice = Vprix.reduce((accumulator, currentValue) => accumulator + (currentValue * quantite), 0);
        setPrix(totalPrice);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, quantite]);   // avant : aucune dépendance → recalcul à chaque render

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/commande/idVariantproduit/${variante}/${taille}`);
                setIdVarianteProduit(data[0].id_varianteProduit);
                setStock(data[0].stock);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN, variante, taille]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/commande/commandeOne/${idCommande}`);
                setGetCommande(data[0]);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN, id_commande]);

    const showModal = () => {
        // Repartir propre : une correction de prix saisie lors d'un essai
        // précédent ne doit pas se reporter sur l'échange suivant.
        setApercu(null);
        setApercuErreur(null);
        setPrixRetenu(null);
        setEditPrix(false);
        setIsModalVisible(true);
    };

    // Même variante des deux côtés (même pointure/couleur) : l'échange n'a de sens
    // que si l'ancienne part en avarie (règle serveur, postEchangeLivraison).
    //
    // CORRECTIF : ce contrôle comparait `idVariant` (la variante CLIQUÉE au
    // catalogue) à `idVarianteProduit` (la variante du MÊME article, résolue pour
    // la pointure choisie). Les deux sont égales dès qu'on garde la pointure de la
    // carte cliquée — c'est-à-dire dans le cas NORMAL — donc l'écran refusait des
    // échanges parfaitement valides (constaté : Satin Noir P42 → Satin Blanc P43).
    // La paire d'ORIGINE n'entrait jamais dans la comparaison.
    //
    // On compare désormais l'ORIGINE (transmise par EchangeForm) au REMPLACEMENT
    // effectivement retenu. Si l'origine est inconnue (ancien lien sans le
    // paramètre), on n'affirme rien : le serveur reste l'autorité et refusera le
    // cas échéant — mieux qu'un blocage à tort.
    const idVarianteOrigine = Number(searchParams.get('id_variante_origine')) || 0;
    const memePaire = idVarianteOrigine > 0 && Number(idVarianteProduit) > 0
        && idVarianteOrigine === Number(idVarianteProduit);

    // Le <select> stocke l'id_taille ; pour l'affichage on résout le libellé réel
    // (« P39 »), sinon le récap montrait « P<id_taille> » (ex. « P5 »).
    const tailleLabel = getTaille?.find((s) => String(s.id_taille) === String(taille))?.taille ?? taille;

    // Wizard : reset à l'ouverture + navigation étape par étape avec garde-fous.
    useEffect(() => { if (isModalVisible) setEtape('type'); }, [isModalVisible]);
    const goBack = () => setEtape(etape === 'recap' ? 'mode' : 'type');
    const goNext = () => {
        if (etape === 'type') {
            if (memePaire && !avarieAncienne) {
                Swal.fire({ title: 'Type d\'échange', text: 'Même pointure/couleur : choisissez « Paire défectueuse » (l\'ancienne part en avarie).', icon: 'warning', confirmButtonText: 'OK' });
                return;
            }
            setEtape('mode');
        } else if (etape === 'mode') {
            if (aLivrer && !(Number(livreur) > 0)) {
                Swal.fire({ title: 'Livreur requis', text: 'Choisissez le livreur qui exécutera l\'échange.', icon: 'warning', confirmButtonText: 'OK' });
                return;
            }
            setEtape('recap');
        }
    };

    const handleOk = async () => {
        // Anti double-envoi + validations : ① même pointure ⇒ avarie obligatoire ;
        // ② « à livrer » ⇒ livreur obligatoire (sinon la mission naît orpheline).
        if (isLoading) return;
        if (memePaire && !avarieAncienne) {
            Swal.fire({ title: 'Type d\'échange requis', text: 'Même pointure/couleur : choisissez « Paire défectueuse » (l\'ancienne part en avarie).', icon: 'error', confirmButtonText: 'OK' });
            return;
        }
        if (aLivrer && !(Number(livreur) > 0)) {
            Swal.fire({ title: 'Erreur', text: 'Choisissez le livreur qui exécutera l\'échange.', icon: 'error', confirmButtonText: 'OK' });
            return;
        }
        // « À livrer » : la ligne d'origine (id_detail) est indispensable — c'est elle qui
        // fixe la variante ANCIENNE côté serveur. Sans elle, on refuse (fail-closed).
        if (aLivrer && !(Number(idDetail) > 0)) {
            Swal.fire({ title: 'Erreur', text: 'Ligne d\'origine introuvable : rouvrez l\'échange depuis la demande ou la commande.', icon: 'error', confirmButtonText: 'OK' });
            return;
        }
        setIsModalVisible(false);
        setIsLoading(true);

        try {
            if (aLivrer) {
                // Cas B : le livreur exécutera l'échange plus tard (mouvements de stock
                // différés à l'exécution). Si l'ancienne est défectueuse, elle sera mise
                // en avarie à ce moment-là (avarie_ancienne), pas remise au stock vendable.
                await axios.post(`${DOMAIN}/api/livraison/echange-a-livrer`, {
                    id_commande: idCommande,
                    // La variante ANCIENNE (paire rendue) est dérivée côté serveur depuis
                    // la ligne d'origine (id_detail_commande) — JAMAIS depuis le remplacement.
                    // idVariant = produit de remplacement : l'envoyer comme « ancienne »
                    // recréditait le mauvais article au stock à l'exécution.
                    id_detail_commande: idDetail,
                    id_variante_nouvelle: idVarianteProduit,
                    id_livreur: livreur,
                    quantite: quantite,
                    // Prix UNITAIRE retenu pour la nouvelle paire (le serveur en
                    // fait la vente à l'exécution et recalcule la dette). On
                    // envoyait auparavant le prix TOTAL (catalogue × quantité) :
                    // au-delà d'une paire, la vente partait au prix du lot.
                    // `prix` (total) reste le repli si l'aperçu n'a pas chargé.
                    prix: prixEchange !== null ? prixEchange : prix,
                    avarie_ancienne: avarieAncienne,
                });
            } else {
                // Cas A (magasin, immédiat). Si l'ancienne paire est défectueuse, elle
                // part en avariées (avarie_ancienne) au lieu de revenir au stock vendable.
                await axios.post(`${DOMAIN}/api/vente/echangeLivraison`, {
                    id_commande: idCommande,
                    id_varianteProduit: idVarianteProduit,
                    quantite: quantite,
                    prix: prix,
                    id_livreur: livreur,
                    quantite_prix: prix,
                    qte_livre: quantite,
                    qte_commande: quantite,
                    id_taille: taille,
                    id_user_cr: userId,
                    id_type_mouvement: 7,
                    id_detail_commande: idDetail,
                    avarie_ancienne: avarieAncienne,
                });
            }

            // Après succès : on QUITTE l'écran vers le Centre des échanges — sinon
            // « Envoyer » restait cliquable et un 2ᵉ envoi créait un échange en double.
            await Swal.fire({
                title: 'Succès',
                text: aLivrer ? 'Échange à livrer créé — le livreur l\'exécutera.' : 'Échange effectué avec succès !',
                icon: 'success',
                confirmButtonText: 'OK',
            });
            navigate('/echangeForm');
            return;

        } catch (err) {
            Swal.fire({
                title: 'Erreur',
                // Remonter le motif serveur (ex. « Stock insuffisant ») plutôt que
                // le générique « Request failed with status code 4xx » d'axios.
                text: err?.response?.data?.error || err?.message,
                icon: 'error',
                confirmButtonText: 'OK',
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleClick = (e) => {
        e.preventDefault();

        if (!taille) {
            Swal.fire({
                title: 'Erreur',
                text: 'Veuillez choisir une pointure',
                icon: 'error',
                confirmButtonText: 'OK',
            });
            return;
        }
        
        showModal();
    };

    return (
        <>
            <div className="detailProduitCommande">
                <h1>Echange</h1>
                {loading ? (
                    <div className="spinner-container">
                        <FadeLoader color={'#36D7B7'} loading={loading} />
                    </div>
                ) : (
                    <div className="detailProduit-wrapper">
                        {result.map((dd) => (
                            <div className="detail-container-bottom">
                                <div className="detail-container-rows">
                                    <div className="detail-bottom-left">
                                        <NdoeImage src={dd.img} alt={dd.nom_produit || 'Article'} size="hero" />
                                    </div>
                                    <div className="detail-bottom-right">
                                        {(dd?.code_article || dd?.code_produit) && (
                                          <span className="num" style={{ color: '#8a5a10', fontWeight: 700, fontSize: 13 }}>
                                            {dd.code_article || dd.code_produit}
                                          </span>
                                        )}
                                        <h1 className="product-titre">{dd?.nom_produit}</h1>
                                        <h2 className="product-titre" style={{color:'#6d6c6c', fontSize:'17px'}}>{dd?.nom_marque}</h2>
                                        <p className="product-desc">{dd?.code_pays}</p>
                                        <p className="product-desc">Il y a {inventaireTotalOne} article{inventaireTotalOne === 1 ? '' : "s"} en stock</p>
                                        {/* Notation/avis fictifs retirés. Prix derrière useMontantsEchange. */}
                                        {peutVoirPrix && (
                                          <div className="product-rate">
                                            <span className="product-price">{dd.prix} $</span>
                                          </div>
                                        )}
                                        {peutVoirPrix && quantite > 1 && <span className="product-price">Prix total: {prix} $</span>}
                                        <div className="filter-products">
                                            <div className="filter-product-row">
                                                <div className="filters">
                                                    <span className="filter-titre">Couleur</span>
                                                    <div className={`${dd.description}`} color={dd.description} />
                                                </div>
                                                <div className="filters">
                                                    <span className="filter-titre">Taille</span>
                                                    <select name="id_taille" id="" className='select-filter' onChange={(e) => setTaille(e.target.value)}>
                                                        <option className='taille_pla'>Sélectionnez une pointure</option>
                                                        {getTaille?.sort((a, b) => a.taille - b.taille).map((s) => (
                                                            <option value={s.id_taille} key={s.id_taille}>{s.taille}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="filter-product-row"></div>                          
                                            <div className="filter-product">
                                                <div className="filter">
                                                    <AddIcon className="filter-icon" onClick={() => handleQuantity('inc')} />
                                                    <span className="filter-nb">{quantite}</span>
                                                    <RemoveOutlinedIcon className="filter-icon" onClick={() => handleQuantity('desc')} />
                                                </div>
                                                {taille && quantite > stock && <div style={{color:'red', fontSize:"12px"}}>Il ya que {stock} dans le stock pour cette pointure</div>}
                                                <div className="filter">
                                                    <button className="filter-btn" onClick={handleClick} disabled={taille && quantite > stock ? true : false}>Envoyer</button>
                                                    {isLoading && (
                                                        <div className="loader-container loader-container-center">
                                                            <NdoeSpinner size={28} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {/* Livreur déplacé dans la modale, affiché seulement si « À livrer »
                                                (le mode immédiat n'assigne pas de livreur). */}
                                        </div>
                                    </div>
                                </div>
                                <div className="detail-rows-bottom"> {getCommande && <>
                                    <div className="detail-rows-bottom-left">
                                        <h2 style={{fontSize:'1rem', color:'rgb(1, 35, 138)'}}>Commande N° {idCommande}</h2>
                                        <span style={{fontSize:'.8rem', color:'#6d6c6c'}}>de {getCommande?.nom} de la commune {getCommande?.nom_commune} Av/ {getCommande?.avenue} Q/ {getCommande?.quartier} N° {getCommande?.num}</span>
                                    </div>
                                    <div className="detail-rows-bottom-left">
                                        <h2 style={{fontSize:'1rem', color:'rgb(1, 35, 138)'}}>Contactez de {getCommande?.nom}</h2>
                                        <span className="variant-name" style={{fontSize:'.8rem', color:'#6d6c6c'}}>{getCommande?.telephone}</span>
                                    </div> </>}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {/*
                `centered` N'EST PAS COSMÉTIQUE ICI (30/08/2026).

                Sans lui, antd pose la fenêtre à `top: 100px` : cent pixels de
                hauteur perdus avant même le premier mot. Sur un portable à
                petit écran, l'étape « Valider » dépasse alors le bas de la
                fenêtre et son bouton de confirmation devient inatteignable —
                la carte descend jusqu'à la barre des tâches.

                Avec `centered`, antd remet `top: 0` et supprime la marge
                basse ; la fenêtre est alors bornée à la hauteur de l'écran et
                son contenu défile à l'intérieur. La barre d'action est rendue
                collante en plus (echangeWizard.css) : les deux ensemble, et
                pas l'une des deux, garantissent que « Confirmer » reste visible
                quelle que soit la taille de l'écran.
            */}
            <Modal
                title="Nouvel échange"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                destroyOnClose
                centered
                className="confirmation-modal"
            >
                <div className="ew-wiz">
                    <WizardStepper steps={EW_STEPS} current={etape} />

                    {etape === 'type' && (
                        <div className="ew-step">
                            <h3 className="ew-q">Quel type d'échange ?</h3>
                            <div className="ew-seg">
                                <button type="button" className={`ew-seg__btn${!avarieAncienne ? ' is-active' : ''}`} onClick={() => setAvarieAncienne(false)}>
                                    <b>Standard</b><small>L'ancienne paire revient au stock vendable (changement de pointure/couleur).</small>
                                </button>
                                <button type="button" className={`ew-seg__btn${avarieAncienne ? ' is-active' : ''}`} onClick={() => setAvarieAncienne(true)}>
                                    <b>Paire défectueuse</b><small>L'ancienne part en avariées (invendable). Obligatoire si même pointure/couleur.</small>
                                </button>
                            </div>
                            {memePaire && !avarieAncienne && (
                                <p className="ew-warn">⚠ Même pointure/couleur : choisis « Paire défectueuse » (sinon l'échange sera refusé).</p>
                            )}
                        </div>
                    )}

                    {etape === 'mode' && (
                        <div className="ew-step">
                            <h3 className="ew-q">Comment se fait l'échange ?</h3>
                            <div className="ew-seg">
                                <button type="button" className={`ew-seg__btn${!aLivrer ? ' is-active' : ''}`} onClick={() => setAlivrer(false)}>
                                    <b>Au comptoir</b><small>Immédiat, la cliente est présente. Pas de livraison.</small>
                                </button>
                                <button type="button" className={`ew-seg__btn${aLivrer ? ' is-active' : ''}`} onClick={() => setAlivrer(true)}>
                                    <b>Par livreur</b><small>Le livreur remet la neuve et reprend l'ancienne plus tard.</small>
                                </button>
                            </div>
                            {aLivrer && (
                                <label className="ew-field">
                                    <span>Livreur qui exécutera l'échange <span className="ew-req">*</span></span>
                                    <select className="ew-select" value={livreur} onChange={(e) => setLivreur(e.target.value)}>
                                        <option value="">Sélectionnez un livreur</option>
                                        {getLivreur.map((l) => <option key={l.id} value={l.id}>{l.username}</option>)}
                                    </select>
                                </label>
                            )}
                        </div>
                    )}

                    {etape === 'recap' && (
                        <div className="ew-step">
                            <h3 className="ew-q">On valide l'échange</h3>
                            {result[0]?.img && <NdoeImage src={result[0].img} alt={result[0]?.nom_produit || 'Article'} size="md" className="ew-recap-img" />}
                            <div className="ew-recap">
                                <div className="ew-recap__line"><span>Nouvelle paire</span><b>{result[0]?.nom_produit} · P{tailleLabel} · ×{quantite}</b></div>
                                {/*
                                    UN SEUL PRIX À L'ÉCRAN, JAMAIS DEUX (30/08/2026).

                                    Cette ligne affiche le prix du CATALOGUE multiplié par la
                                    quantité. Le bloc d'écart, juste en dessous, affiche le prix
                                    RETENU pour l'échange — celui que le serveur propose d'après ce
                                    que la cliente a réellement payé, et qui peut avoir été corrigé.
                                    Les deux se contredisent dès qu'un prix a été négocié.

                                    Tant que seul l'admin voyait les montants, la contradiction
                                    restait entre initiés. En ouvrant l'écran aux secrétaires, on
                                    laisserait deux chiffres différents pour la même paire sous les
                                    yeux de qui doit encaisser. On garde donc le prix catalogue
                                    seulement quand le bloc d'écart n'est PAS là : au comptoir, ou
                                    quand l'aperçu a échoué — les cas où c'est la seule information
                                    de prix disponible.
                                */}
                                {peutVoirPrix && !(aLivrer && apercu) && (
                                    <div className="ew-recap__line"><span>Prix</span><b>{prix} $</b></div>
                                )}
                                <div className="ew-recap__line"><span>Type</span><b>{avarieAncienne ? 'Paire défectueuse (avarie)' : 'Standard'}</b></div>
                                <div className="ew-recap__line"><span>Réalisation</span><b>{aLivrer ? 'Par livreur' : 'Au comptoir'}</b></div>
                                {aLivrer && <div className="ew-recap__line"><span>Livreur</span><b>{getLivreur.find((l) => String(l.id) === String(livreur))?.username || '—'}</b></div>}
                                <div className="ew-recap__line"><span>Commande</span><b>#{idCommande} · {getCommande?.nom}</b></div>
                            </div>

                            {/* Écart de prix — uniquement l'échange à livrer, et
                                uniquement pour qui a le droit de voir les montants.

                                L'ÉCHEC, LUI, SE DIT À TOUT LE MONDE (30/08/2026).
                                Le message d'erreur était derrière `peutVoirPrix`,
                                comme les montants : quelqu'un qui n'a pas le droit
                                de voir l'argent confirmait donc un échange dont le
                                calcul avait échoué sans qu'aucun signe ne le lui
                                dise. Cacher un MONTANT est une règle d'accès ;
                                cacher une PANNE n'en est pas une. On garde donc le
                                chiffre pour l'admin et on avertit tout le monde,
                                sans révéler de somme. */}
                            {aLivrer && apercuErreur && (
                                <p className="ew-hint ew-hint--alerte">
                                    {peutVoirPrix
                                        ? apercuErreur
                                        : "Le calcul de l'écart de prix n'a pas abouti. Prévenez la responsable avant de confirmer."}
                                </p>
                            )}
                            {aLivrer && peutVoirPrix && apercu && (
                                <div className="ew-argent">
                                    <div className="ew-argent__ligne">
                                        <span>{apercu.ancienne.vendue ? 'Elle payait' : 'Ancienne paire'}</span>
                                        <b>{apercu.ancienne.prix} $</b>
                                    </div>
                                    <div className="ew-argent__ligne">
                                        <span>Nouvelle paire</span>
                                        <b>{prixEchange} $</b>
                                    </div>
                                    <div className={`ew-argent__total${ecartEffectif > 0 ? ' is-encaisser' : ''}${ecartEffectif < 0 ? ' is-rembourser' : ''}`}>
                                        {ecartEffectif === 0
                                            ? 'Aucun écart — rien à encaisser ni à rembourser'
                                            : `${Math.abs(ecartEffectif)} $ ${ecartEffectif > 0 ? 'à encaisser' : 'à rembourser'}`}
                                    </div>

                                    {editPrix ? (
                                        <div className="ew-argent__edit">
                                            <label>
                                                <span>Prix retenu pour la nouvelle paire</span>
                                                <input
                                                    type="number" min="0" step="1" className="ew-input"
                                                    value={prixRetenu === null ? apercu.prix_propose : prixRetenu}
                                                    onChange={(e) => setPrixRetenu(e.target.value)}
                                                    autoFocus
                                                />
                                            </label>
                                            <button type="button" className="ew-lien" onClick={() => { setPrixRetenu(null); setEditPrix(false); }}>
                                                Revenir au prix proposé ({apercu.prix_propose} $)
                                            </button>
                                        </div>
                                    ) : apercu.peut_ajuster ? (
                                        <button type="button" className="ew-lien" onClick={() => setEditPrix(true)}>
                                            Corriger le prix
                                        </button>
                                    ) : null}
                                </div>
                            )}
                            <p className="ew-hint">{aLivrer
                                ? "L'échange partira dans l'app du livreur ; les mouvements de stock se font à l'exécution."
                                : "L'échange sera finalisé immédiatement au comptoir."}</p>
                        </div>
                    )}

                    <div className="ew-nav">
                        {etape === 'type'
                            ? <button type="button" className="ew-btn ghost" onClick={handleCancel}>Annuler</button>
                            : <button type="button" className="ew-btn ghost" onClick={goBack}>← Retour</button>}
                        {etape === 'recap'
                            ? <button type="button" className="ew-btn primary" disabled={isLoading} onClick={handleOk}>{isLoading ? 'Validation…' : "✓ Confirmer l'échange"}</button>
                            : <button type="button" className="ew-btn primary" onClick={goNext}>Suivant →</button>}
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default EchangeCommande;
